import { generateApiPath } from "@routes/generatePath";
import type { IExtractParams } from "@routes/types";

const pathBase = `/medical-service-provider/reports/services/:id`;

export type IPathBaseParams = IExtractParams<typeof pathBase>;

export const medicalServiceServices = {
  get: (params: IPathBaseParams) => generateApiPath(pathBase, params),
};
